import { useEffect, useState } from "react"
import DrawerThemeContext from "./DrawerThemeContext";

const DrawerThemeProvider = ({ children }: { children: JSX.Element }) => {

    const [drawerTheme, setDrawerTheme] = useState<string>("dark");

    // funcao para verificar o tema
    const checkTheme = () => {

        const theme = localStorage.getItem("drawerTheme");

        if (theme) {
            setDrawerTheme(theme)
        } else {
            setDrawerTheme("dark");
            localStorage.setItem("drawerTheme", "dark");
        }

    }
    // funcao para verificar o tema

    useEffect(() => {
        checkTheme();
    }, []);

    return (
        <DrawerThemeContext.Provider value={{ drawerTheme, setDrawerTheme }}>
            {children}
        </DrawerThemeContext.Provider>
    );

}

export default DrawerThemeProvider;